window.__assetPrefix__ = '/mobile-phones';